import http from "../../helpers/http";
import * as helpers from "../../helpers/api";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
    FETCH_CONTACT_CONTENT,
    FETCH_CONTACT_CONTENT_SUCCESS,
    FETCH_CONTACT_CONTENT_FAILED,
    CONTACT_MESSAGE,
    CONTACT_MESSAGE_SUCCESS,
    CONTACT_MESSAGE_FAILED,
} from "./actionTypes";

export const fetchContact = () => (dispatch) => {
    dispatch({
        type: FETCH_CONTACT_CONTENT,
        payload: null
    });
    http
        .get("contact-page")
        .then(({ data }) => {
            dispatch({
                type: FETCH_CONTACT_CONTENT_SUCCESS,
                payload: data
            });
        })
        .catch((error) => {
            dispatch({
                type: FETCH_CONTACT_CONTENT_FAILED,
                payload: error
            });
        });
};
export const postContact = (formData) => (dispatch) => {
    dispatch({
        type: CONTACT_MESSAGE,
        payload: null
    });
    http
        .post("contact-us", helpers.doObjToFormData(formData))
        .then(({ data }) => {
            if (data.status) {
                toast.success(
                    `${data.msg}`,
                    TOAST_SETTINGS
                );
                dispatch({
                    type: CONTACT_MESSAGE_SUCCESS,
                    payload: data
                });
            } else {
                toast.error(
                    <Text string={data.msg} parse={true} />,
                    TOAST_SETTINGS
                );
                dispatch({
                    type: CONTACT_MESSAGE_FAILED,
                    payload: null
                });
            }
        })
        .catch((error) => {
            dispatch({
                type: CONTACT_MESSAGE_FAILED,
                payload: error
            });
        });
};
